var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSignMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6811 13.085L15.8157 16.79H14.256V15.295L18.1214 11.59L19.6811 13.085ZM21.9867 12.565C21.9867 12.76 21.7833 12.955 21.5798 13.15L19.8845 14.775L19.2742 14.19L21.0373 12.5L20.6304 12.11L20.1557 12.565L18.596 11.07L20.0879 9.705C20.2236 9.575 20.4948 9.575 20.6983 9.705L21.6476 10.615C21.7833 10.745 21.7833 11.005 21.6476 11.2C21.512 11.33 21.3764 11.46 21.3764 11.59C21.3764 11.72 21.512 11.85 21.6476 11.98C21.8511 12.175 22.0545 12.37 21.9867 12.565ZM8.35626 17.7V7.3H13.1032V10.55H16.4938V11.525L17.8501 10.225V9.9L13.7813 6H8.35626C7.61032 6 7 6.585 7 7.3V17.7C7 18.415 7.61032 19 8.35626 19H16.4938C17.2398 19 17.8501 18.415 17.8501 17.7H8.35626ZM13.7813 15.815C13.6457 15.815 13.5101 15.88 13.4422 15.88L13.1032 14.45H12.086L10.6619 15.555L11.0688 13.8H10.0516L9.37346 17.05H10.3907L12.3572 15.36L12.7641 16.855H13.4422L13.7813 16.79V15.815Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSignMenuIcon);
export default __webpack_public_path__ + "static/media/file-sign-menu-icon.1c13f8fd12c10b135c135e13278e8ff3.svg";
export { ForwardRef as ReactComponent };